export const PAGE_SIZE = 20;
export const SUCCESS_CODE = 200;

export const USER_LOGIN_KEY = 'ccm_user_token';
